"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardizeOptions = void 0;
const _ = require("lodash");
/**
 * Converts the different options formats into the verbose format:
 *
 * In:
 * ['foo','bar']
 * {foo:'foo', bar:'bar'}
 * [{label:'foo',value:'foo'},{label:'bar',value:'bar'}]
 *
 * Out:
 * [{label:'foo',value:'foo'},{label:'bar',value:'bar'}]
 */
const standardizeOptions = function (options, autoOrder = false) {
    const standardisedOptions = convertOptionsToStandardOptions(options);
    if (autoOrder) {
        return _.sortBy(standardisedOptions, n => n.value);
    }
    return standardisedOptions;
};
exports.standardizeOptions = standardizeOptions;
function convertOptionsToStandardOptions(options) {
    // Already in correct format. No need to format further
    if (isStdOptions(options)) {
        return options;
    }
    if (isArrayOptions(options)) {
        return options.map(value => ({
            label: value.toString(),
            value
        }));
    }
    if (isKeyedOptions(options)) {
        return Object.keys(options).map(key => ({
            label: key,
            value: options[key]
        }));
    }
    console.error(options);
    throw new Error("Unrecogised format");
}
// [{label:'foo',value:'foo'},{label:'bar',value:'bar'}]
function isStdOptions(options) {
    return (Array.isArray(options) &&
        options.length > 0 &&
        typeof options[0] === "object" &&
        options[0] !== null);
}
// ['foo','bar']
function isArrayOptions(options) {
    return Array.isArray(options) && !isStdOptions(options);
}
// {foo:'foo', bar:'bar'}
function isKeyedOptions(options) {
    return _.isObject(options);
}
//# sourceMappingURL=standardizeOptions.js.map